<template>
  <div class="wait-back" v-loading="loading" element-loading-text="数据加载中" v-cloak>
    <div class="wai-header">
      <div class="header-title">
        <i class="iconfont-erp icondaihuankuan"></i> 待还款(<span>{{ PendingRepayment }}</span
        >)
      </div>
      <div class="header-icon">
        <i class="iconfont-erp icontongbu"></i>
      </div>
    </div>

    <ul class="back-list" v-if="list.length">
      <li class="back-haeder">
        <div class="offer-name">欠款客户</div>
        <div class="offer-price">金额(元)</div>
      </li>
      <li class="back-item" v-for="(item, index) in list" :key="index">
        <router-link :to="{ path: 'customer/cusDetails', query: { Id: item.CustomerId } }">
          <div class="offer-name">{{ item.CustomerName }}</div>
          <div class="offer-price">{{ (item.Arrears - 0).toFixed(2) }}</div>
        </router-link>
      </li>
    </ul>
    <div class="empty-list" style="padding-top:40px;" v-if="!loading && list.length == 0">
      <i class="iconfont-erp iconjingshi"></i>暂无数据
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      PendingRepayment: 0,
      loading: true,
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$ajax
        .post("/api/Customer/GetIndexArrears", {
          Count: 5,
        })
        .then((res) => {
          this.list = res.Customer;
          this.PendingRepayment = res.PendingRepayment;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wait-back {
  margin-top: 20px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 15px;
}

.wai-header {
  overflow: hidden;
  padding: 0 10px 10px;

  .header-title {
    float: left;
    font-size: 16px;
    color: #333333;
    font-weight: bold;

    span {
      color: #0085fe;
    }
  }

  i {
    font-size: 18px;
    font-weight: normal;
  }

  .header-icon {
    float: right;
  }
}

.back-list {
  font-size: 12px;

  li {
    line-height: 26px;
    padding: 0 10px;
  }

  .offer-name {
    width: 75%;
  }

  .offer-price {
    width: 25%;
    text-align: right;
  }
}

.back-haeder {
  color: #999;
  overflow: hidden;

  > div {
    float: left;
  }
}

.back-item {
  overflow: hidden;
  a {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  &:hover a,
  &:hover p {
    color: #09f;
    // background: #f6faff;
  }

  > div {
    float: left;
  }
}
</style>
